import apiClient from "@/api/apiClient";
import { type ChecklistTemplateItem } from "@/supabase.types";
import { spawnCreateApiFunction, spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "checklist_template_items";
const query = "*";

export const apiConfigChecklistTemplateItems: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["title", "description"],
  sortables: ["created_at", "updated_at", "title", "ordering"],
};

export const createChecklistTemplateItem = spawnCreateApiFunction({ table, query });
export const updateChecklistTemplateItem = spawnUpdateApiFunction({ table, query });

export const deleteChecklistTemplateItem = async (match: Partial<ChecklistTemplateItem>) => {
  const { error, ...rest } = await apiClient.from(table).update({ is_deleted: true }).match(match);
  if (error) throw error;

  return { error, ...rest };
};

export const reorderChecklistTemplateItems = async (items: ChecklistTemplateItem[]) => {
  const results = await Promise.all(
    items.map(({ id }, ordering) => apiClient.from(table).update({ ordering }).eq("id", id)),
  );
  if (results.some((result) => result.error)) {
    const error = results.find((result) => result.error);
    if (error) throw error;
  }
};

export const getChecklistTemplateItemsByChecklistTemplate = async (checklist_template_id: string) => {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .eq("is_deleted", false)
    .eq("checklist_template_id", checklist_template_id)
    .order("ordering");

  if (error) throw error;
  return data;
};
